import React, { Component } from "react";
import "./Calendar.css";
import moment from "moment";

class Calendar extends Component {
  constructor() {
    super();
    this.state = {
      dateObject: moment(),
      weekdayshort: moment.weekdaysShort(),
      year: new Date().getFullYear(),
      day: new Date().getDate(),
      month: new Date().getMonth(),
      months: [
        "Januar",
        "Februar",
        "Mart",
        "April",
        "Maj",
        "Jun",
        "Jul",
        "Avgust",
        "Septembar",
        "Oktobar",
        "Novembar",
        "Decembar",
      ],
      calendar: [],
      choosenDate: "",
    };
  }

  componentDidMount = () => {
    this.getDaysInMonth(this.state.month + 1);
    this.getFirstWeekdayOfMonth(this.state.month, this.state.year);
    this.getDatesInMonthDisplay(this.state.month, this.state.year);
    this.getDaysInMonthDisplay(this.state.month, this.state.year);
  };

  getDaysInMonth = (month) => {
    return moment(month, "MM").daysInMonth();
  };

  getFirstWeekdayOfMonth = (month, year) => {
    return new Date(year, month, 1).getDay();
  };

  getPrevMonthYear = (month, year) => {
    if (month == 0) {
      return {
        month: 11,
        year: year - 1,
      };
    }

    return {
      month: month - 1,
      year,
    };
  };

  getNextMonthYear = (month, year) => {
    if (month == 0) {
      return {
        month: month + 1,
        year,
      };
    }
    return {
      month: 11,
      year: year + 1,
    };
  };

  getDatesInMonthDisplay = (month, year) => {
    var daysInMonth = this.getDaysInMonth(month + 1, year);
    var firstWeekday = this.getFirstWeekdayOfMonth(month, year);
    var result = [];
    var prev = this.getPrevMonthYear(month, year);
    var prevDaysInMonth = this.getDaysInMonth(prev.month + 1, prev.year);

    for (var j = firstWeekday - 1; j >= 0; j--) {
      var x = prevDaysInMonth - j;
      result.push([x, false]);
    }

    for (var i = 1; i <= daysInMonth; i++) {
      result.push([i, true]);
    }

    if (result.length < 42) {
      var daysToAdd = 42 - result.length;

      for (var k = 1; k <= daysToAdd; k++) {
        result.push([k, false]);
      }
    }

    this.setState({ calendar: result });
    return result;
  };

  getDaysInMonthDisplay = (month, year) => {
    var daysInMonth = this.getDaysInMonth(month, year);
    var result = [];

    for (var i = 1; i <= daysInMonth; i++) {
      result.push(i);
    }

    return result;
  };

  getCurrentMonth = (index) => {
    var monthsInYear = this.state.months;
    return monthsInYear[index];
  };

  updateDate = () => {
    this.getDaysInMonth(this.state.month);
    this.getFirstWeekdayOfMonth(this.state.month, this.state.year);
    this.getDatesInMonthDisplay(this.state.month, this.state.year);
    this.getDaysInMonthDisplay(this.state.month, this.state.year);
  };

  changeMonthNext = () => {
    var thisMonth = this.state.month;
    var year = this.state.year;
    if (thisMonth == 11) {
      thisMonth = 0;
      year = year + 1;
    } else {
      thisMonth = thisMonth + 1;
    }
    this.setState({ month: thisMonth, year: year }, this.updateDate);
  };

  changeMonthPrev = () => {
    var thisMonth = this.state.month;
    var year = this.state.year;
    if (thisMonth == 0) {
      thisMonth = 11;
      year = year - 1;
    } else {
      thisMonth = thisMonth - 1;
    }
    this.setState({ month: thisMonth, year: year }, this.updateDate);
  };

  handleClick = (day) => {
    var month = this.state.month;
    var year = this.state.year;
    var date = year + "-" + (month + 1) + "-" + day;
    this.setState({ choosenDate: date });
    this.props.updateChild({ start_date: date, firstDate: date });
    return date;
  };
  render() {
    return (
      <div>
        <div>
          <div
            className={
              "calendar_container" +
              (this.props.showFirstPay == true ? " position_edit" : "")
            }
          >
            <div>
              <div>
                <div className="calendar_header">
                  <div
                    className="arrow_calendar"
                    onClick={this.changeMonthPrev}
                  >
                    &#8592;
                  </div>
                  <div className="month_name">
                    {this.getCurrentMonth(this.state.month)}
                  </div>
                  <div
                    className="arrow_calendar"
                    onClick={this.changeMonthNext}
                  >
                    <span>&#8594;</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="calendar_body">
              <div className="day_name">Ned</div>
              <div className="day_name">Pon</div>
              <div className="day_name">Uto</div>
              <div className="day_name">Sre</div>
              <div className="day_name">Čet</div>
              <div className="day_name">Pet</div>
              <div className="day_name">Sub</div>
            </div>
            <div className="calendar_body">
              {this.state.calendar.map((day, i) => (
                <div className="days_area" key={i}>
                  <div
                    className={
                      "day_field " +
                      (day[1] ? " currentMonth" : " notCurrentMonth")
                    }
                    onClick={() => this.handleClick(day[0])}
                  >
                    {day[0]}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Calendar;
